export interface IBaseModel<T> {
  set(params: Partial<T>): void;
}
export default class BaseModel<T> implements IBaseModel<T> {
  constructor(params) {
    this.set(params)
  }

  set(params: Partial<T>): void {
    Object.assign(this, params)
  }
}
